<template>
  <div class="species-card" :class="{ reversed: isReversed }">
    <div class="picture">
      <img :src="pictureUrl" alt="placeholder image" />
    </div>
    <div class="details">
      <h4>{{ title }}</h4>
      <div class="description">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    isReversed: {
      type: Boolean,
      default: false,
    },
    pictureUrl: {
      type: String,
      default: "../../..https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/placeholder-image-smaller.png",
    },
    title: {
      type: String,
      default: "Purus id tellus arcu habitant proin magna. Integer purus",
    },
    description: {
      type: String,
      default:
        "Facilisi viverra dictum augue eu lobortis elit. In et donec habitasse lacus mi commodo elementum.",
    },
  },
};
</script>

<style scoped>
.species-card {
  display: flex;
  justify-content: space-between;
  gap: 64px;
  width: 100%;
  height: 100%;
}

.species-card.reversed {
  flex-direction: row-reverse;
}

.picture {
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 500px;
  height: 369px;
  object-fit: cover;
}

.details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  max-width: 500px;
}

h4 {
  margin: 0;
}

@media screen and (max-width: 800px) {
  .species-card,
  .species-card.reversed {
    flex-direction: column;
    gap: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// Card.vue?9652b7f8